// extracted by mini-css-extract-plugin
module.exports = {"cta":"Cta_cta__KV_oW","alignStart":"Cta_alignStart__YrEPy","alignEnd":"Cta_alignEnd__CHlUF"};